import {
  DELETE_PATIENT_LIST,
  DELETE_PATIENT_LIST_SUCCESS,
  DELETE_PATIENT_LIST_FAILURE,
} from 'store/patientListDelete/patientListDeleteAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const deletepatientListReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_PATIENT_LIST:
      return { ...state, loading: true };
    case DELETE_PATIENT_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case DELETE_PATIENT_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default deletepatientListReducer;
